<h1 class="title">Add Financial Account</h1>

<button class="close-button" (click)="activeModal.close()"><rkt-icon name="times"></rkt-icon></button>

<div class="details-page-edit-form integrated-bank-account-form">
  <div class="form-title">Financial Account Details</div>

  <form [formGroup]="financialAccountForm">
    <rkt-form [form]="financialAccountForm" [fields]="createBAFinancialAccountFormFields" [model]="formModel"></rkt-form>

    <div [hidden]="isExternal">
      <rkt-form [form]="integratedBankForm" [fields]="integratedBankAccountFields" [model]="formModel"></rkt-form>
    </div>

    <div [hidden]="isIntegrated">
      <rkt-form
        [form]="externalBankForm"
        (modelChange)="onAccountNumberChange()"
        [fields]="externalBankAccountFields"
        [model]="formModel"
      ></rkt-form>
    </div>
  </form>

  <form [formGroup]="addressForm">
    <div class="form-title">Billing Info</div>
    <rkt-form [form]="addressForm" [fields]="addressFields" [model]="formModel"></rkt-form>
  </form>

  <div class="buttons">
    <button rktButton type="button" btnType="tertiary" (click)="activeModal.close()">Cancel</button>
    <button rktButton type="submit" (click)="onSubmit()" [disabled]="formInvalid" title="Continue">Continue</button>
  </div>
</div>
